<script lang="ts">
    import { createEventDispatcher } from 'svelte'
    import ZinputExpander from './zinput-expander.svelte'

    export let value: any[] = []
    export let options: { value: any; label: string; group?: string; disabled?: boolean }[] = []
    export let disabled = false
    export let labeled = false
    export let label = ''
    export let htmlInput = null

    const dispatch = createEventDispatcher()

    let selectOptions: { group: string; options: { value: any; label: string; disabled?: boolean }[] }[] = []

    $: loadOptions(options)

    function loadOptions(opts) {
        const grouped: typeof selectOptions = []
        for (const option of opts || []) {
            const found = grouped.find((el) => el.group === option.group)
            if (found) {
                found.options.push(option)
            } else {
                grouped.push({ group: option.group, options: [option] })
            }
        }
        selectOptions = grouped
    }

    $: safeValue = Array.isArray(value) ? value : []

    $: selectedLabel = safeValue.length === 0 ? '' : safeValue.length === 1 ? '1 opção selecionada' : `${safeValue.length} opções selecionadas`

    function isSelected(v, sel) {
        return sel.includes(v)
    }

    function groupValues(group) {
        return group.options.map((o) => o.value)
    }

    function selectOption(opt, group, sel) {
        if (disabled || opt.disabled) return
        if (isSelected(opt.value, sel)) return
        const siblingValues = groupValues(group)
        value = [...sel.filter((v) => !siblingValues.includes(v)), opt.value]
        dispatch('change')
    }

    function onOptionKeydown(ev, opt, group, sel) {
        if (ev.key === 'Enter' || ev.key === ' ') {
            ev.preventDefault()
            selectOption(opt, group, sel)
        }
    }
</script>

<ZinputExpander titulo={label} {disabled} {labeled} bind:htmlInput>
    <svelte:fragment slot="trigger">
        <span class="radioselect_trigger_text">{selectedLabel}</span>
    </svelte:fragment>
    <svelte:fragment slot="panel">
        {#each selectOptions as group}
            {#if group.group}
                <div class="radioselect_group_label">{group.group}</div>
            {/if}
            {#each group.options as opt (opt.value)}
                <div
                    class="radioselect_option"
                    class:radioselect_option-nested={!!group.group}
                    class:disabled={opt.disabled}
                    role="radio"
                    aria-checked={isSelected(opt.value, safeValue)}
                    tabindex="0"
                    on:click={() => selectOption(opt, group, safeValue)}
                    on:keydown={(ev) => onOptionKeydown(ev, opt, group, safeValue)}
                >
                    <input
                        type="radio"
                        class="form-check-input"
                        name={group.group || '__ungrouped'}
                        checked={isSelected(opt.value, safeValue)}
                        disabled={opt.disabled}
                        tabindex="-1"
                    />
                    {opt.label}
                </div>
            {/each}
        {/each}
    </svelte:fragment>
</ZinputExpander>

<style>
    .radioselect_trigger_text {
        flex-grow: 1;
        padding-left: 8px;
    }

    .radioselect_group_label {
        padding: 2px 12px;
        font-weight: 600;
        opacity: 0.9;
    }

    .radioselect_option {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 0px 12px;
        cursor: pointer;
    }

    .radioselect_option input {
        margin-top: 0px;
    }

    .radioselect_option-nested {
        padding-left: 12px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .radioselect_option:hover {
        background-color: #ffffff12;
    }

    :global(.theme_light) .radioselect_option:hover {
        background-color: #00000010;
    }

    .radioselect_option.disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
</style>
